import { useState } from 'react';
import api from '../api';

export default function ImportModal({ onClose, onDone }) {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setBusy(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/import', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setResult(data);
      onDone();
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка импорта');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2>Импорт из Excel</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        {error && <div className="error-msg">{error}</div>}
        {!result ? (
          <form onSubmit={submit}>
            <p className="text-muted mb-2">
              Файл .xlsx с колонками: Тип, Тип оплаты, Получатель, Направление, Статья, Проект,
              Сумма, Источник, Оплатить до, Дата оплаты, Комментарий.
            </p>
            <div className="form-group">
              <input type="file" accept=".xlsx,.xls" onChange={e => setFile(e.target.files[0] || null)} required />
            </div>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>Отмена</button>
              <button type="submit" className="btn-primary" disabled={busy || !file}>{busy ? 'Загрузка...' : 'Импортировать'}</button>
            </div>
          </form>
        ) : (
          <div>
            <p>Импортировано: <strong>{result.imported}</strong></p>
            {result.errors?.length > 0 && (
              <div>
                <p className="text-muted">Ошибки:</p>
                {result.errors.map((e, i) => <div key={i} className="error-msg">{e}</div>)}
              </div>
            )}
            <div className="modal-actions">
              <button className="btn-primary" onClick={onClose}>Готово</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
